export const isAndroidWebview = () => {
  console.log(
    'checking if device is android webview',
    window.JSUtilityInterface
  );
  return (
    typeof window.JSUtilityInterface !== 'undefined' &&
    !!window.JSUtilityInterface.isWebView
  );
};

/**
 * This function is responsible for removing the callback that is called when the permission retry limit is reached.
 * This is specifically useful for Android Webview where we have a retry limit of 2 for permission requests.
 * After the limit is reached, the user needs to be informed to manually allow permissions from settings.
 * @returns void
 */
export const removeOnPermissionRetryLimitReached = () => {
  console.log('removing onPermissionRetryLimitReached callback');
  window.onPermissionRetryLimitReached = null;
};

/**
 * This function is responsible for adding a callback that will be called when the permission retry limit is reached.
 * This is specifically useful for Android Webview where we have a retry limit of 2 for permission requests.
 * After the limit is reached, the user needs to be informed to manually allow permissions from settings.
 * @param {*} onPermissionLimitReached - Callback function to be called when permission retry limit is reached.
 */
export const addOnPermissionRetryLimitReached = onPermissionLimitReached => {
  console.log(
    'adding onPermissionRetryLimitReached callback',
    onPermissionLimitReached
  );
  window.onPermissionRetryLimitReached = () => {
    console.log('permission retry limit reached');
    removeOnPermissionRetryLimitReached();
    onPermissionLimitReached?.();
  };
};

export const requestAudioVideoPermission = async ({
  onException,
  onPermissionAllowed,
  onPermissionDenied,
  onAudioTrackEnded,
  onVideoTrackEnded,
}) => {
  try {
    console.log('Requesting audio and video permissions');
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: true,
    });
    onException?.(null);
    console.log('Audio and video permissions granted');
    onPermissionAllowed?.();

    const listeners = [];

    stream.getAudioTracks().forEach(audioTrack => {
      const handler = () => {
        console.log('Audio track ended, likely due to permission change');
        onException?.(webcamDomException.NotAllowedError);
        onAudioTrackEnded?.();
      };
      audioTrack.addEventListener('ended', handler);
      listeners.push({ track: audioTrack, handler });
    });

    stream.getVideoTracks().forEach(videoTrack => {
      const handler = () => {
        console.log('Video track ended, likely due to permission change');
        onException?.(webcamDomException.NotAllowedError);
        onVideoTrackEnded?.();
      };
      videoTrack.addEventListener('ended', handler);
      listeners.push({ track: videoTrack, handler });
    });

    const cleanup = () => {
      console.log('Cleaning up media stream and event listeners');
      listeners.forEach(({ track, handler }) => {
        track.removeEventListener('ended', handler);
      });
      stream.getTracks().forEach(track => track.stop());
    };

    return { stream, cleanup };
  } catch (err) {
    console.log('Error requesting audio/video permissions', err);
    onPermissionDenied?.();
    onException?.(err.name || err);

    return { stream: null, cleanup: () => {} };
  }
};
